<template>
  <div class="page">
    <div class="page__title">
      {{ getModuleConfig("redeem_coupon_page.form_title") }}
    </div>
    <div
      class="page__desc"
      v-html="getModuleConfig('redeem_coupon_page.form_desc')"
    ></div>
    <div class="page__content" v-if="getModuleConfig('redeem_coupon_page.content')" v-html="getModuleConfig('redeem_coupon_page.content')"></div>

    <coupon-filters
      v-if="$route.params.coupon_hashid"
      class="s-mb-3"
      :options="filterOptions"
      v-model="filter"
    ></coupon-filters>
    <div class="pointes-list">
      <PointCard
        v-for="item in coupons"
        :key="item.id"
        :item="item"
        :show-preview-button="true"
        @exchange="handleExchange"
        @preview="handlePreviewCoupon"
      ></PointCard>
      <PointPagination v-if="filter === 'all'" v-model="page" :totalPage="totalPage"></PointPagination>
      <Popup ref="popupUsage" panelHeight="auto">
        <div slot="title">
          是否確定要使用
          <span class="s-primary">{{ currentCoupon.point.toLocaleString() }}</span>
          點
        </div>
        <div v-if="branchCode" class="s-mb-5 s-text-center">
          兌換店號：{{ branchCode }}
        </div>
        <div class="s-mt-5 s-mb-5 s-text-center">
          請注意，點數一經使用即無法取消
        </div>
        <div slot="actions" class="s-flex s-space-x-2">
          <button
            class="s-btn s-liff-theme-btn-outline s-btn-sm"
            type="button"
            @click="$refs.popupUsage.close()"
          >
            取消
          </button>
          <button
            class="s-btn s-liff-theme-btn s-btn-sm"
            type="button"
            @click="handleConfirm"
          >
            確定
          </button>
        </div>
      </Popup>
      <Popup ref="popupBranchCode" panelHeight="auto">
        <div slot="title">請輸入店號</div>
        <div class="s-mb-5 s-text-center">
          請輸入店號以完成兌換
        </div>
        <input
          v-model="branchCode"
          class="s-mb-5 s-text-center branch-code-input"
          placeholder="請輸入店號"
        />
        <div slot="actions" class="s-flex s-space-x-2">
          <button
            class="s-btn s-liff-theme-btn-outline s-btn-sm"
            type="button"
            @click="$refs.popupBranchCode.close()"
          >
            取消
          </button>
          <button
            class="s-btn s-liff-theme-btn s-btn-sm"
            type="button"
            :disabled="!branchCode"
            @click="handleBranchCodeConfirm"
          >
            確定
          </button>
        </div>
      </Popup>
    </div>
    <coupon-modal ref="couponModal" :coupon="immediateUsageCoupon" />
    <coupon-modal ref="tempCouponModal" :redeem-code-bundle-id="currentCoupon.id" :confirm-from-outside="true" @confirmFromOutside="confirmFromOutside" />
    <coupon-modal ref="previewCouponModal" :preview-mode="true" :redeem-code-bundle-id="currentCoupon.id" />
  </div>
</template>

<script>
import PointCard from "@/pages/Dashboard/Point/PointCard";
import Popup from "@/components/Page/Liff/Shared/Popup";
import PointPagination from "@/pages/Liff/Point/PointPagination";
import CouponModal from "@/components/Page/Liff/CouponList/CouponModal.vue";
import couponApi from '@/apis/liff/v2/coupon';
import pointApi from '@/apis/liff/v2/point';
import { mapActions, mapMutations } from "vuex";
import pointMixin from "@/mixins/liff/point";
import * as consts from "@/consts";
import CouponFilters from "@/pages/Dashboard/Coupon/CouponFilters.vue"

export default {
  mixins: [pointMixin],
  components: {
    PointCard,
    Popup,
    PointPagination,
    CouponModal,
    CouponFilters,
  },
  data() {
    return {
      currentCoupon: {
        id: null,
        point: 0,
      },
      currentOriginalCoupon: {},
      immediateUsageCoupon: null,
      originalCoupons: [],
      //coupons: [],
      filteredCoupons: [],
      eventCode: this.$route.query.event ?? null,
      page: 1,
      totalPage: 1,
      totalCount: 0,
      branchCode: "",
      filter: "all",
    };
  },
  computed: {
    isImmediateUsageType() {
      return this.currentOriginalCoupon?.usage_type === consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE
    },
    needBranchCode() {
      return this.currentOriginalCoupon?.confirm_type === consts.REDEEM_CODE_BUNDLE_CONFIRM_TYPES.BRANCH_CODE
    },
    filterOptions() {
      if (this.$route.params.coupon_hashid && this.filteredCoupons.length > 0) {

        const coupon = this.filteredCoupons.find(c => c.id === this.$route.params.coupon_hashid);

        return [
          { key: "all", text: `全部 (${this.totalCount})` },
          { key: coupon.id, text: coupon.name },
        ];
      } else {
        return [];
      }
    },
    coupons() {
      return (this.filter === "all" ? this.originalCoupons : this.filteredCoupons).map((c) => {
        return {
            id: c.id,
            name: c.name,
            subtitle: c.description || "",
            point: c.config.point_need,
            image: c.thumb_img_url || c.img_url || "",
            quantity: +c.can_take,
            start_at: c.start_at,
            end_at: c.end_at,
          };
      });
    }
  },
  async mounted() {

    if (this.$route.params.coupon_hashid) {          
      this.filter = this.$route.params.coupon_hashid;
    } else {
      await this.fetchCoupons();  
    }
  },
  watch: {
    page() {
      this.fetchCoupons()
    },
    filter() {
      this.fetchCoupons()
    },
    "$route.params.coupon_hashid": {
      immediate: false, 
      async handler(newVal) {
        this.filter = newVal || "all";           
      },
    },
  },
  methods: {
    ...mapActions('liffPoint', [
      'fetchAvailablePoints',
      'fetchExpiringSoonPoints',
    ]),
    ...mapMutations('liffPoint', {
      setLoading: 'SET_LOADING',
    }),
    async fetchCoupons() {
      this.setLoading(true);

      try {
        const params = {
          page: this.page,
          take_type: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT,
          event_code: this.eventCode || '',
        };
        
        const res = await couponApi.getRedeemCodeBundles(params)

        
        this.filteredCoupons =this.$route.params.coupon_hashid? [await couponApi.getRedeemCodeBundle(this.$route.params.coupon_hashid)] : [];
        

        this.originalCoupons = res.data;
       /*  this.coupons = this.originalCoupons.map((c) => {
          return {
            id: c.id,
            name: c.name,
            subtitle: c.description || "",
            point: c.config.point_need,
            image: c.thumb_img_url || c.img_url || "",
            quantity: +c.can_take,
            start_at: c.start_at,
            end_at: c.end_at,
          };
        }); */
        this.totalPage = res.lastPage || 1;
        this.totalCount = res.total || 0;

        

      } catch (error) {
        console.error(error);
        this.$swal({type: "error", title: "載入兌換券失敗"});
      }

      this.setLoading(false);
    },
    handleExchange(coupon) {
      this.currentCoupon = coupon;
      this.currentOriginalCoupon = this.originalCoupons.find(c => c.id === this.currentCoupon.id);

      if (this.isImmediateUsageType) {
        this.handleImmediateCouponExchange();
      } else {
        this.handleBasicExchange();
      }
    },
    handleImmediateCouponExchange() {
      this.$refs.tempCouponModal.open();
    },
    handleBasicExchange() {
      this.$refs.popupUsage.open();
    },
    handleBranchCodeConfirm() {
      this.$refs.popupBranchCode.close();
      this.$refs.popupUsage.open();
    },
    async handleConfirm() {
      this.setLoading(true);

      try {
        const params = {
          branch_code: this.branchCode || '',
          event_code: this.eventCode || '',
        };

        let resp = await pointApi.redeemCouponFromRedeemCodeBundle(
          this.currentCoupon.id,
          params
        );

        this.$swal({
          title: "兌換完成！",
          icon: "success",
          button: "確定",
        }).then(() => {
          this.fetchCoupons();
          this.$refs.popupUsage.close();

          if (this.isImmediateUsageType) {
            this.immediateUsageCoupon = resp.coupon;
            this.$refs.couponModal.open();
          }
        });
      } catch (error) {
        console.error(error);

        let errorMessage = error.response?.data?.message;
        let errorCode = error.response?.data?.error_code;
        this.$swal({
          title: "兌換失敗！",
          text: typeof errorMessage === 'string' ? errorMessage : Object.values(errorMessage).flat(),
          icon: "error",
          button: "確定",
        }).then(() => {
          this.$refs.popupUsage.close();

          if (errorCode === 4002) {
            this.$router.push({ name: "LiffRegisterIndex" });
          }
        });
      }

      this.branchCode = "";
      this.fetchAvailablePoints({ eventCode: this.eventCode });
      this.fetchExpiringSoonPoints({ eventCode: this.eventCode });
      this.setLoading(false);
    },
    async confirmFromOutside() {
      this.$refs.tempCouponModal.close();

      if (this.needBranchCode) {
        this.$refs.popupBranchCode.open();
      } else {
        this.$refs.popupUsage.open();
      }
    },
    handlePreviewCoupon(coupon) {
      this.currentCoupon = coupon
      this.$refs.previewCouponModal.open();
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/shared/components/_fields.scss';

.page {
  padding: 16px 12px;
  background: var(--liff-content_bg_color);
  &__title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;

    &:empty{
      display: none;
    }

  }
  &__desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--liff-secondary_text_color);
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    b {
      color: var(--s-primary);
      font-weight: 600;
    }

    &:empty{
      display: none;
    }
  }
  &__content {
    margin: 10px 20px;
  }
}

.branch-code-input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;

  &:focus {
    border-color: var(--s-primary);
    box-shadow: 0 0 0 2px rgba(var(--s-primary-rgb), 0.2);
  }

  &::placeholder {
    color: #c0c4cc;
  }
}
</style>
